import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	animation: {
		display: "flex",
		flexDirection: "column",
		height: 600,
		justifyContent: "flex-end",
		position: "relative",
		"& .mco-animation-01": {
			bottom: 0,
			left: 0,
			position: "absolute",
			right: 0,
			top: 0,
			zIndex: 0,
			"&::before": {
				background: "rgba(0, 0, 0, 0.55)",
				bottom: 0,
				content: "''",
				left: 0,
				position: "absolute",
				right: 0,
				top: 0,
				zIndex: 3
			}
		}
	},
	container: {
		marginBottom: 350,
		position: "relative",
		zIndex: 1,
		[theme.breakpoints.up("md")]: {
			marginBottom: theme.spacing(10)
		}
	},
	left: {
		[theme.breakpoints.up("md")]: {
			maxWidth: "33%"
		}
	},
	overline: {
		color: "#FFFFFF",
		lineHeight: 1.6,
		paddingLeft: 34,
		position: "relative",
		textShadow: "0 0 10px rgb(0 0 0 / 20%)",
		"&::before": {
			background:
				"linear-gradient(to right, rgba(208,50,20,1) 0%,rgba(208,50,20,1) 10%,rgba(208,50,20,0) 10%,rgba(208,50,20,0) 45%,rgba(208,50,20,1) 45%,rgba(208,50,20,1) 55%,rgba(208,50,20,0) 55%,rgba(208,50,20,0) 90%,rgba(208,50,20,1) 90%,rgba(208,50,20,1) 100%)",
			content: "''",
			height: 14,
			width: 13,
			position: "absolute",
			left: 3,
			top: "50%",
			margin: "-7px 0 0 0",
			transform: "skewX(-22deg)"
		}
	},
	title: {
		color: "#FFFFFF",
		fontSize: "clamp(50px, 8vw, 85px)",
		marginTop: theme.spacing(0.5),
		textShadow: "0 0 10px rgb(0 0 0 / 20%)"
		// wordBreak: "break-all"
	},
	vintage: {
		color: "#FFFFFF",
		fontSize: 33,
		textShadow: "0 0 10px rgb(0 0 0 / 20%)"
	}
}));

export default styles;
